import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ✅ Discover Creators (Brand)
export async function loadAgencyCreatorsApi(payload) {
  try {
    const fd = new FormData();

    fd.append("page_no", payload.page_no || 0);
    fd.append("search", payload.search || "");
    fd.append("platform", payload.platform || "");

    const res = await axios.post(`${apiBaseUrl}agencyapis/get_creators`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;

  } catch {
    return { status: false };
  }
}

// ✅ Creator Detail (Agency)
export async function loadAgencyCreatorDetailApi(creator_id,agency_id) {
  try {
    const fd = new FormData();
    fd.append("creator_id", creator_id);
    fd.append("agency_id", agency_id);

    const res = await axios.post(`${apiBaseUrl}agencyapis/get_creator_detail`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;

  } catch {
    return { status: false };
  }
}

// ✅ Shortlist Creator
export async function shortlistCreatorApi(agency_id, creator_id) {
  try {
    const fd = new FormData();

    fd.append("agency_id", agency_id);
    fd.append("creator_id", creator_id);

    const res = await axios.post(`${apiBaseUrl}agencyapis/shortlist_creator`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;

  } catch {
    return { status: false };
  }
}

// ✅ Remove Shortlist
export async function removeShortlistApi(agency_id, creator_id) {
  try {
    const fd = new FormData();

    fd.append("agency_id", agency_id);
    fd.append("creator_id", creator_id);

    const res = await axios.post(`${apiBaseUrl}agencyapis/remove_shortlist`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;

  } catch {
    return { status: false };
  }
}

// ✅ Get Shortlisted Creators
export async function loadShortlistedCreatorsApi(agency_id) {
  try {
    const fd = new FormData();

    fd.append("agency_id", agency_id);

    const res = await axios.post(`${apiBaseUrl}agencyapis/get_shortlisted`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;

  } catch {
    return { status: false };
  }
}